import React, { Fragment } from "react";
import Overlay from "./Overlay";

/**
 * Modal con su propio disparador.
 *
 * `triggerClassName` deja que cada lugar (header, menú móvil) le dé la forma
 * que le corresponde sin duplicar la lógica de apertura.
 */
const Modal = ({ title, isOpen, setModalIsOpen, triggerClassName, panelClassName = "max-w-[480px]", children }) => (
	<Fragment>
		<button type="button" className={ triggerClassName } onClick={ () => setModalIsOpen(true) }>
			{ title }
		</button>

		{
			isOpen &&
				<Overlay label={ title } onClose={ () => setModalIsOpen(false) }>
					<div className={ `relative w-full bg-white shadow-[0_40px_120px_rgba(0,0,0,.35)] ${panelClassName}` }>
						<button
							type="button"
							onClick={ () => setModalIsOpen(false) }
							aria-label="Cerrar"
							className="absolute right-3 top-3 h-10 w-10 text-3xl font-extralight text-muted transition-colors duration-200 hover:text-ink"
						>
							×
						</button>
						{ children }
					</div>
				</Overlay>
		}
	</Fragment>
);

export default Modal;
